import React, {useEffect} from "react";
import {SubmitHandler, useForm} from "react-hook-form";
import {Disclosure} from "@headlessui/react";
import {LavoratoreFilterSelection} from "@commons/features/lavoratore/lavoratore.api";
import 'moment-recur-ts'
import {InputToggle} from "../../components/Toggle";
import {RangeOptions} from "./RangeOptions";
import {IconChevronUp, IconZoom} from "@tabler/icons-react";

type FormData = Partial<LavoratoreFilterSelection>;

interface LavoratoreFilterProps {
    children?: React.ReactNode;
    filter: LavoratoreFilterSelection,
    onSubmit: SubmitHandler<FormData>,
    onReset?: () => void,
    open: boolean,
    setOpen: (state: boolean) => void,
}

const LavoratoreFilter: React.FC<LavoratoreFilterProps> = ({children, filter, onSubmit, onReset, open, setOpen}) => {
    const defaultValues: Pick<LavoratoreFilterSelection, 'tutti' |
        'inForzaSection' | 'inForza' | 'forceDataDa' | 'forceDataA' |
        'hiredSection' | 'hired' | 'hiredDataDa' | 'hiredDataA' |
        'firedSection' | 'fired' | 'firedDataDa' | 'firedDataA'> = {
        tutti: 'all',

        inForzaSection: false,
        inForza: 'today',
        forceDataDa: null,
        forceDataA: null,

        hiredSection: false,
        hired: 'm',
        hiredDataDa: null,
        hiredDataA: null,

        firedSection: false,
        fired: 'm',
        firedDataDa: null,
        firedDataA: null,
    };
    const currentValues: FormData = {...defaultValues, ...filter};
    const hook = useForm<FormData>({defaultValues: currentValues});

    const inForzaSection: boolean = hook.watch('inForzaSection') as boolean;
    const hiredSection: boolean = hook.watch('hiredSection') as boolean;
    const firedSection: boolean = hook.watch('firedSection') as boolean;
    const isValid = inForzaSection || hiredSection || firedSection;

    useEffect(() => {
        hook.reset(currentValues);
    }, [filter, open]);


    function onHandleSubmit(newValues: FormData) {
        console.log(newValues);
        onSubmit({
            ...newValues,
        });
    }

    return (
        <>
            <div className="my-1 rounded-lg bg-white shadow w-auto">
                <Disclosure>
                    {() => (
                        <>
                            <Disclosure.Button
                                className="relative flex flex-row flex-wrap items-center h-auto w-full rounded-lg bg-blue-200 px-4 py-2 font-medium text-blue-900 text-sm
                                        max-lg:text-xs
                                        focus:outline-none focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-opacity-75"
                                onClick={() => {
                                    setOpen(!open);
                                }}>
                                {children}

                                <IconChevronUp className={`${
                                    open ? 'rotate-180 transform' : ''
                                } absolute right-2 h-5 w-5 text-blue-500`}
                                />
                            </Disclosure.Button>

                            {/* Pannello date */}
                            {open && <Disclosure.Panel className="py-4 px-6 rounded-b-lg" static>
                                {({close}) => {
                                    return (
                                        <form onSubmit={hook.handleSubmit(onHandleSubmit)}>
                                            <div className="flex flex-row flex-wrap max-sm:flex max-sm:flex-col divide-y divide-solid">
                                                <div className="w-full max-sm:w-full py-2">
                                                    <InputToggle name={'inForzaSection'}
                                                                 control={hook.control}
                                                                 defaultValue={currentValues.inForzaSection!}
                                                                 className="place-content-start mb-2"
                                                                 label="In forza"
                                                                 labelPosition="right"/>

                                                    <RangeOptions {...hook} radioGroupName={'inForza'}
                                                                  enabled={inForzaSection}
                                                                  dataDa={currentValues.forceDataDa}
                                                                  dataDaName={'forceDataDa'}
                                                                  dataA={currentValues.forceDataA}
                                                                  dataAName={'forceDataA'}/>
                                                </div>

                                                <div className="w-full max-sm:w-full py-2">
                                                    <InputToggle name={'hiredSection'}
                                                                 control={hook.control}
                                                                 defaultValue={currentValues.hiredSection!}
                                                                 className="place-content-start mb-2"
                                                                 label="Assunti"
                                                                 labelPosition="right"/>

                                                    <RangeOptions {...hook} radioGroupName={'hired'}
                                                                  enabled={hiredSection}
                                                                  dataDa={currentValues.hiredDataDa}
                                                                  dataDaName={'hiredDataDa'}
                                                                  dataA={currentValues.hiredDataA}
                                                                  dataAName={'hiredDataA'}/>
                                                </div>

                                                <div className="w-full max-sm:w-full py-2">
                                                    <InputToggle name={'firedSection'}
                                                                 control={hook.control}
                                                                 defaultValue={currentValues.firedSection!}
                                                                 className="place-content-start mb-2"
                                                                 label="Cessati"
                                                                 labelPosition="right"/>

                                                    <RangeOptions {...hook} radioGroupName={'fired'}
                                                                  enabled={firedSection}
                                                                  dataDa={currentValues.firedDataDa}
                                                                  dataDaName={'firedDataDa'}
                                                                  dataA={currentValues.firedDataA}
                                                                  dataAName={'firedDataA'}
                                                                  addDaSempre/>
                                                </div>
                                            </div>

                                            {/*BUTTONS*/}
                                            <div className="text-right">
                                                <button type="button"
                                                        className="inline-flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600
                                                                    max-lg:mb-1
                                                                    hover:bg-blue-700
                                                                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                                                                    disabled:opacity-50"
                                                        onClick={() => {
                                                            hook.reset(defaultValues);
                                                            setOpen(false);
                                                            if (onReset)
                                                                onReset();
                                                        }}>
                                                    Annulla filtro
                                                </button>
                                                <button type="submit" disabled={!isValid}
                                                        className="ml-2 inline-flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600
                                                                        hover:bg-blue-700
                                                                        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                                                                        disabled:opacity-50">
                                                    Applica & cerca
                                                    <IconZoom className="ml-2 -mr-0.5 h-5 w-5"/>
                                                </button>
                                            </div>
                                        </form>
                                    )
                                }}
                            </Disclosure.Panel>}
                        </>)}
                </Disclosure>
            </div>
        </>
    )
}

export default LavoratoreFilter;